import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetOfferCustomFieldsRequest = App.Http.Requests.Offer.GetOfferCustomFieldsRequest;
import GetOfferCustomFieldsResponse = App.Http.Responses.Offer.GetOfferCustomFieldsResponse;
import StoreOfferCustomFieldRequest = App.Http.Requests.Offer.StoreOfferCustomFieldRequest;
import GetOfferCustomFieldResponse = App.Http.Responses.Offer.GetOfferCustomFieldResponse;
import GetOfferCustomFieldRequest = App.Http.Requests.Offer.GetOfferCustomFieldRequest;
import UpdateOfferCustomFieldRequest = App.Http.Requests.Offer.UpdateOfferCustomFieldRequest;

class OfferCustomFieldApi extends TenantBaseApi {
    async index(offerId: string, request: GetOfferCustomFieldsRequest): Promise<GetOfferCustomFieldsResponse> {
        return await this.get<GetOfferCustomFieldsResponse, GetOfferCustomFieldsRequest>(`/offers/${offerId}/custom-fields`, {
            params: request,
        });
    }

    async store(offerId: string, request: StoreOfferCustomFieldRequest): Promise<GetOfferCustomFieldResponse> {
        return await this.post<GetOfferCustomFieldResponse, StoreOfferCustomFieldRequest>(`/offers/${offerId}/custom-fields`, request);
    }

    async show(offerId: string, fieldId: string, request: GetOfferCustomFieldRequest): Promise<GetOfferCustomFieldResponse> {
        return await this.get<GetOfferCustomFieldResponse, GetOfferCustomFieldRequest>(`/offers/${offerId}/custom-fields/${fieldId}`, {
            params: request,
        });
    }

    async update(offerId: string, fieldId: string, request: UpdateOfferCustomFieldRequest): Promise<GetOfferCustomFieldResponse> {
        return await this.put<GetOfferCustomFieldResponse, UpdateOfferCustomFieldRequest>(`/offers/${offerId}/custom-fields/${fieldId}`, request);
    }

    async destroy(offerId: string, fieldId: string): Promise<void> {
        return await this.delete<void>(`/offers/${offerId}/custom-fields/${fieldId}`);
    }
}

export const offerCustomFieldApi = new OfferCustomFieldApi();
